import React from "react";
import styles from "./action-btns.module.scss";
import { UseQueryResult } from "@tanstack/react-query";
import type { ModPerms } from "@/features/mod-perms/api/get-all-mod-perms";
import AddBtn from "@/features/mod-perms/components/buttons/add-permission-btn/add-permission-btn";
import RefreshBtn from "@/features/mod-perms/components/buttons/refresh-btn";
import RemoveAllBtn from "@/features/mod-perms/components/buttons/remove-all-btn/remove-all-btn";
import SaveChangesBtn from "@/features/mod-perms/components/buttons/save-change-btn/save-changes-btn";

type Props = {
  hideLeftControls?: boolean;
  fetchControls?: UseQueryResult<ModPerms | null, Error>;
};

const ModPermsActionBtns = ({
  hideLeftControls = false,
  fetchControls,
}: Props) => {
  return (
    <div className={styles.buttons}>
      {!hideLeftControls && (
        <div className={styles.actionBtns}>
          <AddBtn />
          <RefreshBtn fetchControls={fetchControls} />
          <RemoveAllBtn />
        </div>
      )}
      <SaveChangesBtn />
    </div>
  );
};

export default ModPermsActionBtns;
